// extracted by mini-css-extract-plugin
export default {"keyword":"KeywordList__keyword--vpYye","keywordListContainer":"KeywordList__keywordListContainer--Gt3bb"};